export default "__VITE_ASSET__cd4219d5__"